import React from 'react'
import moment from 'moment'
import { Icon, Label, Popup } from 'semantic-ui-react'

export default class StatusButton extends React.PureComponent {
  getLabelColor = status => {
    const defaultColor = 'yellow'
    const defaultIcon = 'food'

    const options = {
      pending: {
        text: 'Pending',
        color: 'gray',
        icon: defaultIcon,
      },
      confirmed: {
        text: 'Confirmed',
        color: defaultColor,
        icon: defaultIcon,
      },
      drivers_not_available: {
        text: 'Confirmed',
        color: defaultColor,
        icon: defaultIcon,
      },
      outForDelivery: {
        text: 'Out For Delivery',
        color: 'yellow',
        icon: 'bicycle',
      },
      delivered: {
        text: 'Delivered',
        color: 'green',
        icon: 'check',
      },
      rejected: {
        text: 'Rejected Reason',
        color: 'red',
        icon: 'sticky note',
      },
    }

    return options[status]
  }

  render() {
    const { order } = this.props
    const labelOption = this.getLabelColor(order.status)

    return (
      <Popup
        trigger={
          <Label color={labelOption.color} style={{ width: 150, margin: 0 }}>
            <Icon name={labelOption.icon} />
            {labelOption.text}
          </Label>
        }
        position="top center"
      >
        <div style={{ textAlign: 'center' }}>
          {moment(order.updated_at).format('HH:mm a')}
          <br />
          {moment(order.updated_at).format('DD-MMM-YYYY')}
        </div>

        {order.status === 'rejected' && (
          <div style={{ textAlign: 'center' }}>
            <hr style={{ margin: '3px 0px' }} />
            {order.rejected_description || 'No description'}
          </div>
        )}
      </Popup>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/orders/components/OrderListItem/ActionButtons/Status.js